// Language codes used by the `language` field that
// @sanity/document-internationalization writes on each hub/article document.
export type SanityLanguage = 'en' | 'pt-BR'

// Maps the app's i18next language onto the Sanity document language code.
// Articles are English-only for now, but the mapping keeps the frontend
// ready for the Portuguese versions (AR-623 bilingual requirement).
export const toSanityLanguage = (appLanguage: string): SanityLanguage => {
  return appLanguage.toLowerCase().startsWith('pt') ? 'pt-BR' : 'en'
}
